var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{staticClass:"a",attrs:{"d":"M12,5.99,19.53,19H4.47L12,5.99M12,2,1,21H23Zm1,14H11v2h2Zm0-6H11v4h2Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }